/* eslint-disable react/prop-types */
import React from 'react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'

/**
 * This component will, when rendered on the server, set the passed in status code
 * See https://reacttraining.com/react-router/web/example/static-router for more information
 */
const Status = ({ statusCode, children }) => {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) {
          // If this exists, we know we're being rendered server side with StaticRouter
          staticContext.responseStatus = Number(statusCode) // make sure it's a number or Koa will throw a fit
        }
        return children
      }}
    />
  )
}

Status.propTypes = {
  statusCode: PropTypes.number.isRequired,
  children: PropTypes.node,
}

export default Status
